var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-widget px-1 flex items-center"},[_c('div',{staticClass:"relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600 mr-3"},[_c('span',{staticClass:"font-medium text-gray-600 dark:text-gray-300"},[_vm._v("JL")])]),_c('h4',[_vm._v("Abe Jahwin")])])
}]

export { render, staticRenderFns }